import { createUseStyles } from 'react-jss'
import style from './style'
import {
  Container,
  TypographyElement,
  Review,
  Paper,
  RateStars,
  RateStarSize,
  Row,
  Col,
  Button
} from 'UI'
import Text from './text.json'
import RatingDetailsComponent from './RatingDetail/UI'
import {
  smallLogo
} from 'assets'
import { RatingColor, amazonBucket } from 'constants/'
import { useState } from 'react'
import { nameShortener } from 'helpers'
import { NameInitials } from 'UI/helpers'

const useStyle = createUseStyles(style)

const maxNumberOfReviewsToShow = 4

export default ({ Rating = 0, RatingDetails = [], Reviews = [], ReviewersCount, Title }) => {
  const { paperClass, ratingClass, ratingDetailsClass, ratingContainerClass, paperRatingDetailsClass } = useStyle()
  const [showMore, setShowMore] = useState(false)
  return (
    <Container>
      {
        (!!Rating || !!Reviews.length) &&
          <TypographyElement
            variant='heading2'
            spacing='0 0 24px 0'
            component='h2'
          >
            {Text.title} {Title}
          </TypographyElement>
      }
      {
        !!Rating &&
          <Row>
            <Col grid={5}>
              <Paper noHover className={paperClass}>
                <div className={ratingClass}>
                  <TypographyElement
                    variant='heading5'
                    spacing='0 0 16px 0'
                  >
                    {Text.ratingTitle}
                  </TypographyElement>
                  <div className={ratingContainerClass}>
                    <TypographyElement
                      variant='heading1'
                      fontSize={59}
                      lineHeight='75px'
                      spacing='0 17px 0 0'
                    >
                      {Number(Rating.toFixed(1))}
                    </TypographyElement>
                    <div>
                      <RateStars margin='18px 0 0 0' height={24} value={Rating} size={RateStarSize.extraBig} secondary />
                      <TypographyElement
                        variant='body2'
                        spacing='6px 0 0 0'
                      >
                        {`(${ReviewersCount} ${Text.review})`}
                      </TypographyElement>
                    </div>
                  </div>
                </div>
              </Paper>
            </Col>
            <Col grid={7}>
              <Paper noHover className={paperRatingDetailsClass}>
                <div className={ratingDetailsClass}>
                  {
                  RatingDetails?.map(rating =>
                    <RatingDetailsComponent
                      key={rating.label}
                      review={rating.label}
                      reviewCount={rating.value}
                      totalReview={ReviewersCount}
                      color={RatingColor[rating.label]}
                    />
                  )
                }
                </div>
              </Paper>
            </Col>
          </Row>
      }
      {
        (showMore ? Reviews : Reviews.slice(0, maxNumberOfReviewsToShow)).map((review) =>
          <Review
            key={review.Id}
            authorImage={review.AuthorImage ? `${amazonBucket.bucketBaseUrl}${review.AuthorImage}` : null}
            authorName={nameShortener({ firstName: review.FirstName, lastName: review.LastName })}
            authorInitials={NameInitials(`${review.FirstName}${review.LastName}`)}
            rating={review.Rating}
            opinion={review.Opinion}
            showMoreLabel={Text.showMoreLabel}
            showLessLabel={Text.showLessLabel}
            showAlphormResponseLabel={Text.showAlphormResponseLabel}
            teamAlphormName={Text.teamAlphormName}
            alphormResponse={review.Response}
            smallLogo={smallLogo}
            reviewDate={review.Date}
            margin='0 0 16px 0'
            responseDate={review.ResponseDate}
          />
        )
      }
      {
        !showMore && Reviews.length > maxNumberOfReviewsToShow &&
          <Row justify='center'>
            <Col grid={12}>
              <Button
                onHandleClick={() => setShowMore(true)}
                variation='text'
                size='big'
                label={Text.showMoreReviews}
                marginButton='8px 0 0 0'
              />
            </Col>
          </Row>
      }
    </Container>
  )
}
